import { React, useState, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { filterBy, orderBy } from "@progress/kendo-data-query";

import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import moment from "moment";

const initialSort: any[] = [
  {
        field: "fields.updated",
    dir: "desc",
  },
];

interface SupportCasesGridProps {
  data?: any | null;
}

const SupportCasessGrid = (props: SupportCasesGridProps) => {
  const [data, setData] = useState(props.data || []);
  const [sort, setSort] = useState(initialSort);
  const [isPagable, updateIsPagable] = useState(false);
  const [filter, setFilter] = useState();
  const [page, setPage] = useState({
    skip: 0,
    take: 4,
  });
    useEffect(() => {
        if (props.data != null) {
            setData(props.data);
        }
  }, [props.data]);

  const pageChange = (event) => {
    setPage(event.page);
  };
  const filterChange = (event: any) => {
    if (props.data != null) {
      setData(filterBy(props.data, event.filter));
      setFilter(event.filter);
    }
  };

  const createdCell = (cellProps: any) => {
    return (
      <td>{moment(cellProps.dataItem.fields.created).format("DD.MM.YYYY")}</td>
    );
  };
  const updatedCell = (cellProps: any) => {
    return (
      <td>{moment(cellProps.dataItem.fields.updated).format("DD.MM.YYYY")}</td>
    );
  };
    const IDCell = (cellprops: any) => {
        const key = cellprops.dataItem.key;
        const href = `https://primapower-jira.atlassian.net/browse/${encodeURIComponent(
            key
        )}`;

        return (
            <td>
                <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {key}
                </a>
            </td>
        );
    };
  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-38px",
          left: "0px"
        }}
      >
        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
          pageable={isPagable}
          // data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
                  data={Array.isArray(data) ? orderBy(data, sort) : []}
                  total={Array.isArray(data) ? data.length : 0}
          // skip={page.skip}
          // take={page.take}
          //   onPageChange={pageChange}

          filterable={true}
          filter={filter}
          //scrollable={"virtual"}
          onFilterChange={filterChange}
          sortable={true}
          sort={sort}
          onSortChange={(e: any) => {
            setSort(e.sort);
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Column field="key" title="ID" cell={IDCell} />
          <Column field="fields.summary" title="Summary" />
          <Column field="fields.assignee.displayName" title="Assignee" />

          <Column field="fields.reporter.displayName" title="Reporter" />

          <Column field="fields.status.name" title="Status" />

          <Column field="fields.created" title="Created" cell={createdCell} />

          <Column field="fields.updated" title="Updated" cell={updatedCell} />
        </Grid>
      </ExcelExport>
    </div>
  );
};
export default SupportCasessGrid;
